import { useTranslation } from '@framework/i18n';
import * as React from 'react';
import { ErrorResultA11y } from './ErrorResultA11y';
import { OnPageResultContainer } from './OnPageResultContainer';

/**
 * Props condivise tra i componenti di errore.
 */
export interface IErrorResultBodyProps {
  message?: React.ReactNode;
  description?: React.ReactNode;
  title?: string;
}
/**
 * Componente per errore generico network.
 */
export function ErrorResultBody(props: IErrorResultBodyProps) {
  const { message, description, title } = props;
  const { t } = useTranslation();

  return (
    <OnPageResultContainer>
      <ErrorResultA11y
        status="error"
        title={title ?? t('alert.error-result-body.title', 'Errore Network')}
        subTitle={
          message ??
          t(
            'alert.error-result-body.message',
            'Sì è verificato un errore nella richiesta.',
          )
        }
        extra={description}
      />
    </OnPageResultContainer>
  );
}
